import produce from 'immer';

import { Types, consultaNomeSocial } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: consultaNomeSocial = {
	status: 0,
	data: null,
};

export default function consultaNomeSocialReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaNomeSocial {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_NOME_SOCIAL_REQUEST: {
				break;
			}
			case Types.CONSULTA_NOME_SOCIAL_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_NOME_SOCIAL_FAILURE: {
				draft.status = 400;
				break;
			}
			case Types.CONSULTA_NOME_SOCIAL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
